import { InnerContentItem, OuterContentItem } from "@certn/cascadia-react";
import { formatDate } from "@certn/utils";
import { ArrayControlProps } from "@jsonforms/core";
import { useTranslation } from "react-i18next";

interface Education {
  country: string;
  institution: {
    name: string;
  };
  qualification: string;
  subject: string;
  start_date: string;
  is_currently_attending?: boolean;
  date_awarded?: string;
  grade: string;
  name_on_qualification?: string;
}

export function EducationHistorySummaryControl(props: ArrayControlProps) {
  const { t } = useTranslation();

  const educations = props.data as Education[];

  return (
    <>
      {educations?.map((education, index) => (
        <OuterContentItem
          key={index}
          title={education.subject}
          subtitle={education.institution.name}
          testID={`education-summary-${index + 1}`}
        >
          <InnerContentItem
            label={t("Institution")}
            testID={`education-summary-institution-name-${index + 1}`}
          >
            {education.institution.name}
          </InnerContentItem>
          <InnerContentItem
            label={t("Qualification")}
            testID={`education-summary-qualification-${index + 1}`}
          >
            {education.qualification}
          </InnerContentItem>
          <InnerContentItem
            label={t("Subject")}
            testID={`education-summary-subject-${index + 1}`}
          >
            {education.subject}
          </InnerContentItem>

          <InnerContentItem
            label={t("Start date")}
            testID={`education-summary-start-date-${index + 1}`}
          >
            {formatDate(education.start_date, "MMMM yyyy")}
          </InnerContentItem>

          {education.date_awarded && (
            <InnerContentItem
              label={t("Date Awarded")}
              testID={`education-summary-date-awarded-${index + 1}`}
            >
              {formatDate(education.date_awarded, "MMMM yyyy")}
            </InnerContentItem>
          )}
        </OuterContentItem>
      ))}
    </>
  );
}
